import { IconButton, Select, Text } from '~/shared/ui'
import { useFilters, usePaginationSelectors } from '../model'

export function PaginationBar() {
  const { filters, setFilters } = useFilters()
  const {
    currentPage,
    setCurrentPage,
    hasPreviousPage,
    hasNextPage,
    startRow,
    endRow,
    resetPagination,
  } = usePaginationSelectors({ pageSize: filters.pageSize })

  return (
    <div className="border-divider flex items-center justify-end gap-8 border-t px-6 py-3">
      <div className="flex items-center gap-2">
        <Text appearance="BODY2">Rows per page</Text>
        <Select
          className="w-20"
          name="pageSize"
          value={filters.pageSize}
          onValueChange={(value) => {
            const pageSize = Number(value)
            resetPagination()
            setFilters({ pageSize })
          }}
        >
          <Select.Item value={50}>50</Select.Item>
          <Select.Item value={100}>100</Select.Item>
          <Select.Item value={500}>500</Select.Item>
        </Select>
      </div>

      <Text appearance="BODY2">{`${endRow === 0 ? '0' : startRow} - ${endRow}`}</Text>

      <div className="flex items-center gap-4">
        <IconButton
          size="medium"
          container="small"
          materialIcon="chevron_left"
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={!hasPreviousPage}
        />
        <IconButton
          size="medium"
          container="small"
          materialIcon="chevron_right"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={!hasNextPage}
        />
      </div>
    </div>
  )
}
